const printStyle = `
    @page {
        size: a4 !important;
        margin: 0.39in !important;
    }
    html,
    body {
        background: #fff !important;
        overflow-x: hidden;
    }
    .app-body, .main{
      height: 100% !important;
    } 
    .protocolo-consulta__imprimir__print {
        display: block !important;
    }
    .protocolo-consulta__imprimir__print .react-bs-table {
      border: 0;
    }
    .protocolo-consulta__imprimir__print .react-bs-table td{
      font-size: 0.75rem !important;
    }
    .protocolo-consulta__imprimir__print .react-bs-table table td,
    .protocolo-consulta__imprimir__print .react-bs-table table th {
      vertical-align: middle !important;
      overflow: initial !important;
      white-space: normal !important;
      word-break: break-word !important;
    }
    .protocolo-consulta__imprimir__print .react-bs-table,
    .protocolo-consulta__imprimir__print .react-bs-table .react-bs-container-body {
      height: auto !important;
    }
    .protocolo-consulta__imprimir__print .react-bs-table span.order.fa-sort{
      display: none;
    }
`;

export { printStyle };